<div class="member-search chase-detail-form">
  <div class="ui-md-3 ui-toolbar-group-left">

    <div class="ui-g-12 ui-md-12 ui-lg-12 member-search-selection">
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <form-factory class="member-search_existing-member"[formGroup]="formGroupMemberOption"
                      [model]="existingMemberOptions"></form-factory>
      </div>
    </div>

    <div class="ui-fluid" *ngIf="showMemberForm">
      <form [formGroup]="formGroupMemberSearch"
            class="chase-detail-form">
        <div class="ui-g-12 ui-md-12 ui-lg-12" *ngIf="!searchMemberControls && !isPrePopulatedFromSearch">
          <p>
            Please create a new member by completing the fields below:<br />
            Then click the "Add Member" button.
          </p>
        </div>

        <div class="ui-g-12 ui-md-12 ui-lg-12" *ngIf="isPrePopulatedFromSearch">
          <p>
            Member details have been pre-populated from your selection.<br />
            Please enter the Sample ID and click "Next Step".
          </p>
        </div>

        <div class="ui-g-12 ui-md-12 ui-lg-12" *ngIf="searchMemberControls">
          <form-factory [formGroup]="formGroupMemberSearch"
                        [model]="memberIdInput"></form-factory>
        </div>

        <div class="ui-g-12 ui-md-12 ui-lg-12" *ngIf="!searchMemberControls && !isPrePopulatedFromSearch">
          <form-factory [formGroup]="formGroupMemberSearch"
                        [model]="clientMemberIdInput"></form-factory>
        </div>

        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <form-factory [formGroup]="formGroupMemberSearch"
                        [model]="enrolleeIdInput"></form-factory>
        </div>

        <div class="ui-g-12 ui-md-12 ui-lg-12" *ngIf="isHEDISProjectSelected">
          <form-factory [formGroup]="formGroupMemberSearch"
                        [model]="sampleIdInput"></form-factory>
        </div>

        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <form-factory [formGroup]="formGroupMemberSearch"
                        [model]="memberFirstNameInput"></form-factory>
        </div>

        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <form-factory [formGroup]="formGroupMemberSearch"
                        [model]="memberMiddleNameInput"></form-factory>
        </div>

        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <form-factory [formGroup]="formGroupMemberSearch"
                        [model]="memberLastNameInput"></form-factory>
        </div>

        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <form-factory [formGroup]="formGroupMemberSearch"
                        [model]="memberDateOfBirthInput"></form-factory>
        </div>

        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <form-factory [formGroup]="formGroupMemberSearch"
                        [model]="memberGenderInput"></form-factory>
        </div>

        <div class="ui-g-12 ui-md-12 ui-lg-12 label-container" *ngIf="isClientEnrolleeIdInvalid">
            <div *ngFor="let message of validationErrorMessages trackBy: trackByIndex">
              <span class="ellipsis text-danger">{{ message }}</span>
            </div>
          </div>

        <div class="ui-md-12">
          <app-button class="ui-md-6 reset-button text-left" text="RESET" (onClick)="reset()"></app-button>
          <app-button *ngIf="searchMemberControls && !isPrePopulatedFromSearch" [disabled]="!isMemberSearchFormHasValues" class="ui-md-6 process-button text-right" text="SEARCH" (onClick)="searchMember()"></app-button>
          <app-button *ngIf="isPrePopulatedFromSearch" class="ui-md-6 process-button text-right" text="NEXT STEP" (onClick)="nextStep()"></app-button>
          <app-button *ngIf="!searchMemberControls && !isPrePopulatedFromSearch" class="ui-md-6 process-button text-right" [disabled]="!isAddNewMemberAllowed" text="ADD MEMBER" (onClick)="createMember()"></app-button>
        </div>

      </form>
    </div>
  </div>

  <div class="ui-md-8 ui-toolbar-group-left ml-2" *ngIf="searchMemberControls && !isPrePopulatedFromSearch">
    <div *ngIf="memberCount<=0" class="grids-display">
      <div class="ellipsis text-center"><h2>No member found matching your search criteria.</h2></div>
    </div>
    <div class="grids-display" *ngIf="isMemberResultsFound">
      <h3>{{memberCount}} RESULT(S)</h3>
      <app-basic-grid class="grids-display"
                      [configuration]="memberSearchGridConfiguration"
                      [data]="memberSearchData"
                      [(selection)]="memberGridSelection"
                      [actionTemplate]="memberActionTemplate">
      </app-basic-grid>
    </div>
    <div class="ui-md-12 ui-toolbar-group-left text-right process-button padding-right-0" *ngIf="!isShowNextStepButton">
      <app-button class="button"
                  (onClick)="nextStep()"
                  text="NEXT STEP"></app-button>

    </div>
  </div>

</div>

<ng-template #memberActionTemplate let-rowData let-localActionPopover="actionPopover">
  <div class="action-template-container">
    <app-button text="Use this Member and update Sample ID" (onClick)="useExistingMemberWithSampleId(rowData); localActionPopover.hide()"></app-button>
  </div>
</ng-template>
